export type Testimonial = {
  quote: string
  author: string
  role: string
  url?: string
}

/**
 * PRE-LAUNCH: real public quotes from coaches (VOC, verified 25-09-2026 on the
 * full source page), always shown with their source. They describe the
 * problem; they are NOT reviews of this product.
 * After launch, replace with real buyer reviews (with permission). US FTC
 * rules prohibit fabricated reviews.
 */
const FSU_MIXED =
  'https://www.fsuniverse.net/forum/threads/advice-on-teaching-skating-classes-with-multiple-levels.107977/'

export const shortTestimonials: Testimonial[] = [
  {
    quote: 'I am teaching classes with multiple levels in them.',
    author: 'Group class instructor',
    role: 'FSUniverse forum · January 2021',
    url: FSU_MIXED,
  },
  {
    quote: 'I have to split the class into two groups for most of the class.',
    author: 'Group class instructor',
    role: 'FSUniverse forum · January 2021',
    url: FSU_MIXED,
  },
  {
    quote:
      "I don't have time to work with individual kids, and I don't have time to even watch them do what I tell them to do.",
    author: 'Group class instructor',
    role: 'FSUniverse forum · January 2021',
    url: FSU_MIXED,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      "I'd come up with a circuit or maybe two drawn on the ice to work on whatever you want to work on.",
    author: 'Reply to the instructor',
    role: 'FSUniverse forum · January 2021',
    url: FSU_MIXED,
  },
  {
    quote: 'Maybe the slower kids have an inside track, faster kids outside.',
    author: 'Reply to the instructor',
    role: 'FSUniverse forum · January 2021',
    url: FSU_MIXED,
  },
  {
    quote:
      "When you're supposed to know all the answers the pressure can feel overwhelming.",
    author: 'Figure skating coach',
    role: 'Coach blog · July 2025',
    url: 'https://www.akcstyle.com/blog/why-i-almost-quit-figure-skating-coaching',
  },
]
